/**
 * Responsive breakpoint constants and utilities
 * Standardized breakpoints for consistent device detection across the application
 */

export const BREAKPOINTS = {
  MOBILE: 768,    // Mobile devices (< 768px) - Phones up to 430px
  TABLET: 1024,   // Tablet devices (768px - 1024px) - iPad, Android tablets
  // Desktop: > 1024px - Laptops (1280px+) and Desktops (1920px+)
};

export const DEVICE_TYPES = {
  MOBILE: 'mobile',
  TABLET: 'tablet',
  DESKTOP: 'desktop',
};

/**
 * Get current device type based on window width
 * @returns {string} Device type: 'mobile', 'tablet', or 'desktop'
 */
export const getDeviceType = () => {
  if (typeof window === 'undefined') return DEVICE_TYPES.DESKTOP;
  
  const width = window.innerWidth;
  if (width < BREAKPOINTS.MOBILE) {
    return DEVICE_TYPES.MOBILE;
  } else if (width < BREAKPOINTS.TABLET) {
    return DEVICE_TYPES.TABLET;
  }
  return DEVICE_TYPES.DESKTOP;
};

/**
 * Check if current device is mobile
 * @returns {boolean}
 */
export const isMobile = () => {
  return getDeviceType() === DEVICE_TYPES.MOBILE;
};

/**
 * Check if current device is tablet
 * @returns {boolean}
 */
export const isTablet = () => {
  return getDeviceType() === DEVICE_TYPES.TABLET;
};

/**
 * Check if current device is desktop
 * @returns {boolean}
 */
export const isDesktop = () => {
  return getDeviceType() === DEVICE_TYPES.DESKTOP;
};

/**
 * Check if current device is mobile or tablet
 * @returns {boolean}
 */
export const isMobileOrTablet = () => {
  const type = getDeviceType();
  return type === DEVICE_TYPES.MOBILE || type === DEVICE_TYPES.TABLET;
};

/**
 * Get current orientation
 * @returns {string} 'portrait' or 'landscape'
 */
export const getOrientation = () => {
  if (typeof window === 'undefined') return 'landscape';
  return window.innerHeight > window.innerWidth ? 'portrait' : 'landscape';
};

/**
 * Check if device is in portrait mode
 * @returns {boolean}
 */
export const isPortrait = () => {
  return getOrientation() === 'portrait';
};

/**
 * Check if device is in landscape mode
 * @returns {boolean}
 */
export const isLandscape = () => {
  return getOrientation() === 'landscape';
};

